import { FC, PropsWithChildren, type ReactNode } from 'react';
import { Button, Flex } from 'antd';
import styled from 'styled-components';
import { Main } from './Main';
import { Spinner } from './Spinner';
import { TextSecondary } from './typography';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './PopupView.translations.json';

const { addTranslations, t } = i18nNsFactory('popup-view');
addTranslations(translations);

export interface PopupViewProps extends PropsWithChildren {
  title?: string;
  actions?: ReactNode;
  footer?: ReactNode;
  contentId?: string;
  isLoading?: boolean;
}

export const PopupView: FC<PopupViewProps> = ({
  title,
  actions,
  footer,
  children,
  contentId,
  isLoading,
}) => (
  <Main>
    <Main.Col>
      {isLoading && <StyledSpinner overlay />}
      <StyledMainHeader>
        {title && (
          <small style={{ textTransform: 'uppercase' }}>
            <strong>
              <TextSecondary>{title}</TextSecondary>
            </strong>
          </small>
        )}
        <ButtonsWrapper gap="middle">
          {actions}
          <Button
            id="close-window"
            type="primary"
            onClick={() => window.close()}
          >
            {t('button.close')}
          </Button>
        </ButtonsWrapper>
      </StyledMainHeader>
      <Main.Content padding={false} scrollable={false}>
        <Main style={{ position: 'relative' }}>
          <Main.Col border={false}>
            <StyledMainContent padding={false} id={contentId}>
              {children}
            </StyledMainContent>
            {footer && <Main.Footer>{footer}</Main.Footer>}
          </Main.Col>
        </Main>
      </Main.Content>
    </Main.Col>
  </Main>
);

const StyledMainHeader = styled(Main.Header)`
  border: 0;
`;

const StyledMainContent = styled(Main.Content)`
  background: white;
`;

const StyledSpinner = styled(Spinner)`
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1;
`;

const ButtonsWrapper = styled(Flex)`
  margin-left: auto;
`;
